import { render, staticRenderFns } from "./ActionButtons.vue?vue&type=template&id=0a6a804e&scoped=true"
import script from "./ActionButtons.vue?vue&type=script&lang=js"
export * from "./ActionButtons.vue?vue&type=script&lang=js"
import style0 from "./ActionButtons.vue?vue&type=style&index=0&id=0a6a804e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6a804e",
  null
  
)

export default component.exports